package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListApaleoProperty(
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?,

)